import { useState } from 'react'
import { useNavigate } from 'react-router'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import Markdown from 'react-markdown'
import helpContent from '../docs/how-it-works.md?raw'
import routes from '../pages/routes'

const HelpDialog = () => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  return (
    <>
      <IconButton
        color='inherit'
        onClick={() => setOpen(true)}
        aria-label='help'
      >
        <HelpOutlineIcon />
      </IconButton>

      <Dialog open={open} onClose={() => setOpen(false)} fullScreen>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1, pr: 1 }}>
          <IconButton
            onClick={() => setOpen(false)}
            aria-label='close'
            size='small'
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ pt: 0 }}>
          <Markdown>{helpContent}</Markdown>
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Button
              variant='contained'
              onClick={() => {
                setOpen(false)
                navigate(routes.support)
              }}
            >
              Get Support
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default HelpDialog
